import SearchConstants from 'constants/search';
import SearchService from 'services/search';
import SearchStore from 'stores/anyroad/search';
import Flux from 'lib/flux';

const shouldSearch = function (store) {
  return store.state.get('filtering') !== true;
};

const SearchActionCreator = Flux.createActionCreator({
  updateAvailabilityDates(fromDate, toDate) {
    this.dispatchAction(
      SearchConstants.UPDATE_AVAILABILITY_DATES,
      fromDate,
      toDate
    );
    this.search();
  },

  updateAvailabilityPeople(value) {
    this.dispatchAction(SearchConstants.UPDATE_AVAILABILITY_PEOPLE, value);
    this.search();
  },

  updateCategories(value) {
    this.dispatchAction(SearchConstants.UPDATE_CATEGORIES, value);
    this.search();
  },

  doneFiltering() {
    this.dispatchAction(SearchConstants.FILTER_COMPLETED);
    this.search();
  },

  cancelledFiltering() {
    this.dispatchAction(SearchConstants.FILTER_COMPLETED);
  },

  goToPage(page) {
    this.dispatchAction(SearchConstants.CHANGE_PAGE, page);
    this.search();
  },

  appendPage(page) {
    this.dispatchAction(SearchConstants.APPEND_PAGE, page);
    this.search();
  },

  sortBy(sortingOption) {
    this.dispatchAction(SearchConstants.SORT_BY, sortingOption);
    this.search();
  },

  filter() {
    this.dispatchAction(SearchConstants.FILTER);
  },

  search() {
    const self = this;

    if (shouldSearch(SearchStore)) {
      this.dispatchAction(SearchConstants.SEARCH);
      SearchService.fetchTours().then(function (resp) {
        self.dispatchAction(SearchConstants.SEARCH_COMPLETED, resp);
      });
    }
  },

  inquire(params) {
    const self = this;

    this.dispatchAction(SearchConstants.INQUIRE);
    SearchService.postInquiry(params)
      .then(function (resp) {
        self.dispatchAction(SearchConstants.INQUIRE_COMPLETED, resp);
      })
      .catch(function (resp) {
        let payload;
        if (!resp.status || resp.status >= 500) {
          payload = { errors: { base: 'Something went wrong.' } };
        } else {
          payload = resp.responseJSON;
        }
        self.dispatchAction(SearchConstants.INQUIRE_FAILED, payload);
      });
  },
});

export default SearchActionCreator;
